import { Injectable, OnDestroy } from '@angular/core';
import {
  EditQualifiedPersonInviteCommand,
  QPInviteTotalType,
  QualifiedPersonInviteSearchViewModelQPInviteTotalTypePagedResultResponse
} from '@services/cleanfill-api/cleanfill-api.generated';
import { AuthService } from '@services/core/auth.service';
import { SearchQuery } from '@view-models/search-query/search-query';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { HttpQpService } from '../http-qp/http-qp.service';

@Injectable({
  providedIn: 'root'
})
export class StoreQpInvitationService implements OnDestroy {
  legalEntityId$: Observable<string>;
  qpInvitationsPagedResultSubj$ = new BehaviorSubject<QualifiedPersonInviteSearchViewModelQPInviteTotalTypePagedResultResponse>(null);
  qpInvitationsPagedResult$ = this.qpInvitationsPagedResultSubj$.asObservable();
  qpInvitations$ = this.qpInvitationsPagedResult$.pipe(
    map(result => result?.records.filter(inv => inv.status === QPInviteTotalType.Pending) || [])
  );
  totalQPInvitations$ = this.qpInvitationsPagedResult$.pipe(
    map(v => v?.totals?.find(total => total.type === (QPInviteTotalType.Pending as string))?.value || 0)
  );
  subscriptions = new Subscription();

  constructor(private qpHttp: HttpQpService, private authService: AuthService) {
    this.legalEntityId$ = this.authService.activeUserLegalEntityUniqueId$;
  }
  async loadQPInvitations(query: SearchQuery): Promise<void> {
    const legalEntityId = (await this.legalEntityId$.pipe(filter(Boolean), take(1)).toPromise()) as string;
    const sub = this.qpHttp.loadQpInvitations(legalEntityId, query).subscribe(res => this.qpInvitationsPagedResultSubj$.next(res));
    this.subscriptions.add(sub);
  }
  editQualifiedPersonInvite(payload: EditQualifiedPersonInviteCommand, fn: () => void) {
    const sub = this.qpHttp.editQualifiedPersonInvite(payload).subscribe(fn);
    this.subscriptions.add(sub);
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
